export default __webpack_public_path__ + "static/media/slowdeathstrike1.d748ad98.png";